import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const getWishlistProps = z
  .object({
    token: z.string(),
    items: z.number().optional(),
    page: z.number().optional(),
  })
  .extend(requestConfig.shape);

export type GetWishlistProps = z.infer<typeof getWishlistProps>;

export const getWishlist = async (
  args: GetWishlistProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    items,
    page,
    proxyAuthSecret,
  } = parseServiceInput(getWishlistProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret ? { "X-NG-Proxy-Auth": proxyAuthSecret } : {}),
  });

  const params = new URLSearchParams();
  if (page) params.set("page", page.toString());
  if (items) params.set("pageSize", items.toString());

  const response = await fetch(`${endpoint}/v3/wishlist?${params.toString()}`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed HUEHUE",
  });
};
